<template>
  <v-layout wrap>
    <v-flex
      xs12
      md4
    >
      <v-autocomplete
        v-model="form.region"
        :disabled="disabled || loadingRegions"
        :items="regions"
        label="SELECCIONAR REGIÓN"
        item-text="name"
        item-value="id"
        :rules="rules.region"
        :error="!!formErrors.region"
        :error-messages="formErrors.region"
        @keyup="
          () => {
            formErrors.region = undefined;
            delete formErrors.region;
          }
        "
      />
    </v-flex>

    <v-flex
      xs12
      md4
    >
      <v-autocomplete
        v-model="form.province"
        :disabled="disabled || loadingProvinces"
        :items="filteredProvince"
        label="SELECCIONAR PROVINCIA"
        item-text="name"
        item-value="id"
        :rules="rules.province"
        :error="!!formErrors.province"
        :error-messages="formErrors.province"
        @keyup="
          () => {
            formErrors.province = undefined;
            delete formErrors.province;
          }
        "
      />
    </v-flex>

    <v-flex
      xs12
      md4
    >
      <v-autocomplete
        v-model="form.district"
        :disabled="disabled || loadingDistricts"
        :items="filteredDistrict"
        label="SELECCIONAR DISTRITO"
        item-text="name"
        item-value="id"
        :rules="rules.district_id"
        :error="!!formErrors.district_id"
        :error-messages="formErrors.district_id"
        @keyup="
          () => {
            formErrors.district_id = undefined;
            delete formErrors.district_id;
          }
        "
      />
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AppUbigeo',
  props: {
    /*
    form: {
      required: false,
      type: Object,
      default: function () {
        return {
          region: 8,
          province: 76,
          district: 80901
        }
      }
    }, */
    regions: {
      required: true, type: Array, default: function () { return [] }
    },
    provinces: {
      required: true, type: Array, default: function () { return [] }
    },
    districts: {
      required: true, type: Array, default: function () { return [] }
    },
    disabled: {
      required: false, type: Boolean, default: false
    }
  },
  watch: {
    $data: {
      handler (val, oldVal) {
        this.$emit('changed', val.form)
      },
      deep: true
    }
  },
  computed: {
    ...mapState({
      loadingRegions: state => state.regions.loadingRegions,
      loadingProvinces: state => state.provinces.loadingProvinces,
      loadingDistricts: state => state.districts.loadingDistricts
    }),
    filteredProvince () {
      return this.provinces.filter(o => o.region_id === this.form.region)
    },
    filteredDistrict () {
      return this.districts.filter(o => o.province_id === this.form.province)
    }
  },
  created () {
    if (this.data) { this.form = { ...this.data } }
    this.$emit('changed', this.form)
  },
  methods: {
    getData () {
      return {
        region: this.form.region,
        province: this.form.province,
        district: this.form.district
      }
    }
  },
  data () {
    return {
      form: {
        region: 8,
        province: 809,
        district: 80901
      },
      formErrors: {},
      rules: {
        region: [v => !!v || 'Indicar región'],
        province: [v => !!v || 'Indicar provincia'],
        district: [v => !!v || 'Indicar distrito']
	      }
    }
  }
}
</script>
